import Fetch from 'jsx/common/util/_fetch';

const api = {
  fetchActivityLogs: async (urlParams: string) => {
    const baseUrl = '/api/activitylog/';
    const url = urlParams.length ? `${baseUrl}?${urlParams}` : baseUrl;

    const result = await Fetch.get(url);
    if (result.status >= 400) throw Error(result.statusText);

    const data = await result.json();
    return data;
  },

  fetchActivityLogFilters: async (dateRangeUrlParams: string) => {
    const baseUrl = '/api/activitylog/filters/';

    const url = dateRangeUrlParams.length
      ? `${baseUrl}?${dateRangeUrlParams}`
      : baseUrl;
    const result = await Fetch.get(url);
    if (result.status >= 400) throw Error(result.statusText);

    const data = await result.json();
    return data;
  },
};
export default api;
